<template>
    <div class="app-body-container" style="padding-bottom: 30px">

        <!--详情-->
        <el-row class="mg-t-10">
            <el-col :span="24">
                <el-card shadow="hover" class="mycard-a">

                    <!--返回-->
                    <div style="padding-bottom: 20px">
                        <el-button class="mybtn-ret" @click="xTo({path:'/inventory/search'})">返回</el-button>
                    </div>

                    <div v-loading="goods_loading">
                        <!--标题-->
                        <div class="search-detail-title">
                            <img src="@/assets/search-detail-title.png">
                            <span class="txt">{{goods.goodsName}} / {{goods.skuVname}} / {{goods.unitName}}</span>
                        </div>

                        <!--仓库列表-->
                        <div class="cangku-list">

                            <div class="cangku-item" v-for="(item,idx) in whList" :key="idx">
                                <div class="cangku-content">
                                    <div class="cc-title">{{item.whName}}</div>
                                    <ul>
                                        <li>  <span class="cc-item-name">可用库存：</span>  <span class="cc-item-val">{{item.stocks|formatNumber}}</span>  </li>
                                        <li>  <span class="cc-item-name">当前库存：</span>  <span class="cc-item-val">{{item.stocks|formatNumber}}</span>  </li>
                                        <li>  <span class="cc-item-name">成本价（元）：</span>  <span class="cc-item-val">{{item.cost|formatMoney}}</span>  </li>
                                        <li>  <span class="cc-item-name">库存总额（元）：</span>  <span class="cc-item-val">{{item.money|formatMoney}}</span>  </li>
                                        <li>  <span class="cc-item-name">临期库存： </span>  <span class="cc-item-val red">{{item.expiration}}</span>  </li>
                                    </ul>
                                </div>
                                <div class="cangku-foot" v-if="idx === 0">
                                    <span>保质期：{{goods.qaDay}}天</span>
                                    <span class="f-r">最佳销售期：{{goods.bestSelling}}天</span>
                                </div>
                                <div class="cangku-foot" v-if="idx !== 0">
                                    <i class="el-icon-edit-outline"></i>
                                </div>
                            </div>

                        </div>
                    </div>

                </el-card>
            </el-col>
        </el-row>

        <!--列表-->
        <el-row class="mg-t-10">
            <el-col :span="24">
                <el-card shadow="hover" class="mycard-a">

                    <!--查询条件-->
                    <el-form :inline="true" class="myform" style="padding-bottom: 5px">
                        <el-form-item label="仓库">
                            <el-select placeholder="请选择" v-model="main$query_whId" @change="fetchData">
                                <el-option v-for="(item,idx) in data_warehouse" :key="idx" :label="item.whName" :value="item.whId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="来源">
                            <el-select placeholder="请选择" v-model="main$query_dataSource" @change="fetchData">
                                <el-option v-for="(item,idx) in data_dataSource" :key="idx"  :label="item.value" :value="item.code"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>

                    <!--选项卡-->
                    <el-tabs type="card" value="in" class="mytabs" @tab-click="handleTabChange">
                        <el-tab-pane name="in">
                            <span slot="label">
                                入库记录
                            </span>
                        </el-tab-pane>
                        <el-tab-pane name="out">
                            <span slot="label">
                                出库记录
                            </span>
                        </el-tab-pane>
                    </el-tabs>

                    <!--表格、分页-->
                    <el-table :data="main$data" v-loading="main$loading" size="medium">
                        <el-table-column prop="orderDay" label="时间" width="200" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="incrs" label="变更数量" width="200" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="curStocks" label="剩余数量" width="200" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="whName" label="仓库" width="200" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="cost" label="成本价" width="200" v-if="main$query_type!='out'" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="dataSourceStr" label="来源" align="center" header-align="center"> </el-table-column>
                    </el-table>
                    <div style="margin: 14px">
                        <el-pagination style="float: right"
                                       background
                                       layout="total, sizes, prev, pager, next"
                                       :page-size="main$page_size"
                                       :current-page="main$curr_page"
                                       :total="main$total"
                                        @current-change="handlePageChange"></el-pagination>
                        <div style="clear: both;"></div>
                    </div>

                </el-card>
            </el-col>
        </el-row>

    </div>
</template>

<script>
export default {
    data: function () {
        return {
            id: null,
            // 商品详情
            goods_loading:false,
            goods: {},
            whList: [],
            // 下拉框数据
            data_warehouse:[],
            data_dataSource:[],
            // 表格数据
            main$query_whId: '',
            main$query_dataSource: '',
            main$query_type: '',
            main$page_size: 10,
            main$curr_page: 1,
            main$loading: false,
            main$total: 0,
            main$data: []
        }
    },
    methods:{
        fetchData: function(){
            let self = this;

            self.main$loading = true

            let post = {
                skuId: self.id,                           // 单品ID
                whId: self.main$query_whId,              // 仓库ID
                dataSource: self.main$query_dataSource, // 数据来源
                page: self.main$curr_page,
                rows: self.main$page_size,
            }

            let url = self.main$query_type == 'out' ? '/robot/stock/getGoodsOut' : '/robot/stock/getGoodsIn'

            self.xFetch.post(self.xApi(url), post,{xPostType:'form'}).then(function (res) {
                self.main$loading = false

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    self.main$total = 0;
                    self.main$data = [];
                }
                else {
                    self.main$total = res.data.total;
                    self.main$data = res.data.rows;
                }
            });
        },
        handlePageChange: function (val) {
            this.main$curr_page = val;
            this.fetchData();
        },
        handleTabChange: function (tab, e) {
            if (tab.name == 'out') this.main$query_type = 'out';
            else this.main$query_type = 'in';

            this.main$curr_page = 1;
            this.fetchData();
        },
    },
    created: function(){
      let self = this

      // check id
      self.id = self.$route.query.id;
      if (!self.id) {
        self.xTo({path: '/inventory/search'})
        return;
      }

      // 加载商品详情
      self.goods_loading = true
      self.xFetch.post(self.xApi('/robot/stock/getGoods'), {
        id: self.id
      },{xPostType:'form'}).then(function (res) {
        self.goods_loading = false

        if (res.data.code != '00') {
          self.xEui.msg_error(res.data.text)
          self.xTo({path: '/inventory/search'})
          return
        }
        self.goods = res.data.data;
        self.whList = res.data.data.whList;
      });

      // 下拉框数据
      self.xFetch.post(self.xApi('/robot/common/getWarehouse'), {}).then(function (res) {
        if (res.data.code != '00') {
          self.xEui.msg_error(res.data.text)
          return
        }
        self.data_warehouse = res.data.data;
      });
      self.xFetch.post(self.xApi('/robot/common/getDataSource'), {}).then(function (res) {
        if (res.data.code != '00') {
          self.xEui.msg_error(res.data.text)
          return
        }
        self.data_dataSource = res.data.data;
      });

      // 加载表格数据
      self.fetchData();
    },
    // keep-alive事件
    activated: function(){
        let self = this

        // check id
        self.id = self.$route.query.id;
        if (!self.id) {
            self.xTo({path: '/inventory/search'})
            return;
        }

        // 加载商品详情
        self.goods_loading = true
        self.xFetch.post(self.xApi('/robot/stock/getGoods'), {
            id: self.id
        },{xPostType:'form'}).then(function (res) {
            self.goods_loading = false

            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                self.xTo({path: '/inventory/search'})
                return
            }
            self.goods = res.data.data;
            self.whList = res.data.data.whList;
        });

        // 下拉框数据
        self.xFetch.post(self.xApi('/robot/common/getWarehouse'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            self.data_warehouse = res.data.data;
        });
        self.xFetch.post(self.xApi('/robot/common/getDataSource'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            self.data_dataSource = res.data.data;
        });

        // 加载表格数据
        self.fetchData();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /*search-detail-title*/
    .search-detail-title{ }
    .search-detail-title img{ height: 50px }
    .search-detail-title .txt{
        font-size: 16px;
        color: #303133;
        font-weight: 700;
        display: inline-block;
        height: 50px;
        line-height: 50px;
        vertical-align: top;
        margin-left: 15px;
    }
    /*cangku-list*/
    .cangku-list{ padding-top: 3px }
    .cangku-list:after{ content: '';display: table;clear: both }
    .cangku-list .cangku-item{ width: 288px;float: left;margin-top: 16px;margin-left: 16px; }
    .cangku-list .cangku-item:nth-child(1),
    .cangku-list .cangku-item:nth-child(2),
    .cangku-list .cangku-item:nth-child(3),
    .cangku-list .cangku-item:nth-child(4){ margin-top: 0; }
    .cangku-list .cangku-item:nth-child(4n-3){ margin-left: 0 }
    .cangku-list .cangku-content{ height: 136px;border: 1px solid #EAEAEA;background: #F8F8F8;padding: 20px }
    .cangku-list .cangku-content .cc-title{ font-size: 14px;font-weight: 700;margin-bottom: 15px}
    .cangku-list .cangku-content ul{ margin: 0;padding: 0;list-style: none }
    .cangku-list .cangku-content ul li{ display: block ;line-height: 22px}
    .cangku-list .cangku-content .cc-item-name{ font-size: 13px;color: #707090; }
    .cangku-list .cangku-content .cc-item-val{ font-size: 13px;color: #333; float: right;width: 60px;text-align: left}
    .cangku-list .cangku-content .cc-item-val.red{color: #ee152f }
    .cangku-list .cangku-foot{ padding-top: 20px;height: 20px;font-size: 14px;color:#303133; }
    .cangku-list .cangku-foot .f-r{  float: right }
    .cangku-list .cangku-foot .el-icon-edit-outline{ font-size: 18px;margin-left: 20px }
</style>



// WEBPACK FOOTER //
// src/views/inventory/search-detail.vue